// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/presentation-chart-line.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/presentation-chart-line'

import { Icon, type IconComponentProps } from '../icon'

export const PresentationChartLineIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
